import { IBaseLine } from "./IBaseLine";

export class HCFALine implements IBaseLine {
  amount: number = 0;
  cpt: string = '';
  desc: string = '';
  diagnosis: string = '';
  emg: string = '';
  fromDt: number = NaN;
  modifier: string = '';
  pos: string = '';
  repriced: number = 0;
  rev: string = '';
  toDt: number = NaN;
  type: string = 'HCFA';
  units: number = 0;
}